<template>
    <div class="login__form is-success">
        <div class="login__success">
            <div class="login__success-loading" />

            <h3 class="login__success-title">
                {{ justRegistered ? 'Учетная запись создана!' : 'Пользователь найден!' }}
            </h3>
            <div class="login__success-description">
                Вы будете перенаправлены <br>в&nbsp;личный кабинет
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex';
import {redirectAfterAuth} from '@/helpers/authRedirect';

export default {
    name: 'Success',

    props: {
        justRegistered: {
            type   : Boolean,
            default: false
        }
    },

    data() {
        return {
            loading      : false, // Запущен ли лоадер
            hasLoaded    : false, // Завершилась ли загрузка успехом
            redirectTimer: null,
        };
    },

    async created() {
        await this.getTokenAction();
    },

    beforeDestroy() {
        clearTimeout(this.redirectTimer);
    },

    methods: {
        ...mapActions(['getToken', 'getUserData']),

        /**
         * Получение токена
         */
        async getTokenAction() {
            try {
                const response = await this.getToken();
                const {data} = response;

                if (data?.error) {
                    this.returnError({
                        code: data?.notCounter ? 1 : 3
                    });

                    this.launchLoader(false);
                    return;
                }

                // messageCode: 
                // messageCode: 
                // 0 - Ошибка интеграции
                // 1 - Токены созданы в СРМ и Базисе
                // 2 - Токены созданы в СРМ. Клиента нет в Базисе
                // 3 - Токены созданы в СРМ. Ошибка интеграции в Базисе
                // 4 - Клиент не найден
                const messageCode = data?.data?.messageCode;
                const keys = Object.keys(data?.data || {});
                const requiredKeys = ['accessToken', 'expiresIn', 'expiresInRefresh'];
                let isRequiredKeysExists = true;

                requiredKeys.forEach(key => {
                    if (!keys.includes(key) || !data.data[key] || data.data[key] === '') {
                        isRequiredKeysExists = false;
                    }
                });

                if (!messageCode || messageCode === 0 || messageCode === 4 || !isRequiredKeysExists) {
                    this.returnError({
                        code: 1
                    });
                    this.launchLoader(false);
                    return;
                }

    
                try {
                    await this.$store.dispatch('setTokens', {
                        accessToken     : data?.data?.accessToken,
                        expiresIn       : data?.data?.expiresIn,
                        expiresInRefresh: data?.data?.expiresInRefresh,
                    });
                } catch (error) {
                    this.returnError({
                        code: 5,
                        data: error.response
                    });
                    return;
                }
                
                try {
                    await this.getUserData();
                } catch (error) {
                    // профиль не пришёл — redirectAfterAuth уведёт на дозаполнение
                }

                this.redirectTimer = setTimeout(() => {
                    this.redirectTimer = null;
                    this.goToPage('/appointments');
                }, 3000);
            } catch (error) {
                this.launchLoader(false);
                this.returnError({
                    code: 5,
                    data: error.response
                });
            }
        },

        /**
         * Переходим в личный кабинет или на дозаполнение профиля
         * @param link {String} - адрес
         */
        goToPage(link) {
            redirectAfterAuth(this.$router, this.$store, link);
        },

        /**
         * Возвращает ошибку в общую форму
         * @param code {Number} - код ошибки. 1 - ошибка обработки запроса в CRM. 2 - Блокировка на время. 3 - Ошибка со счётчиком попыток. 4 - Блокировка при привышении кол-ва попыток. 5 - Ошибка на сервере
         * @param data {Object} - данные для показа ошибки
         */
        returnError({code, data = null}) {
            if (this.justRegistered) {
                this.$store.commit('SET_USER_DATA', {});
            }

            this.$emit('goToBack');
            this.$emit('showError', {code, data});
        },

        /**
         * Запуск/остановка лоадера
         * @param status {Boolean} - Вкл/выкл лоадер
         */
        launchLoader(status) {
            this.loading = status;
        },

        /**
         * Успешное завершение лоадера лоадера
         */
        completeLoader() {
            this.hasLoaded = true;
            this.launchLoader(false);
        },
    }
};
</script>
